require('prismjs/themes/prism.css')

const addScript = (url) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  document.body.appendChild(script)
}

export const onClientEntry = () => {
  window.onload = () => {
    addScript('https://cdn.polyfill.io/v2/polyfill.min.js')
  }
}
